/**
 * OpenAI 影像生成提供商設定 schema。
 *
 * 與 `ai-provider.schema`(LiteLLM,文字 LLM)平行獨立:
 *   `ai.provider` 用來做 AI 每日追蹤之類的 chat completions
 *   `openai.image-provider`(本檔)專責生圖(gpt-image-1 / dall-e-3)
 *
 * 欄位刻意比 LiteLLM 精簡:生圖呼叫不需要 temperature / maxTokens。
 * DB 只存一組,key='openai.image-provider';apiKey 以 AES-256-GCM 加密。
 */
import { z } from 'zod';

/** 使用者輸入。apiKey 留空代表「保留原值」。 */
export const OpenAiImageProviderSettingInputSchema = z.object({
  enabled: z.boolean().default(false),
  baseUrl: z
    .string()
    .trim()
    .url()
    .or(z.literal(''))
    .default('https://api.openai.com/v1'),
  apiKey: z.string().max(500).default(''),
  model: z.string().trim().min(1).max(100).default('gpt-image-1'),
  dailyCostUsd: z.coerce.number().min(0).max(1000).default(5),
});
export type OpenAiImageProviderSettingInput = z.infer<
  typeof OpenAiImageProviderSettingInputSchema
>;

export const OpenAiImageProviderSettingViewSchema = z.object({
  enabled: z.boolean(),
  baseUrl: z.string(),
  hasApiKey: z.boolean(),
  model: z.string(),
  dailyCostUsd: z.number(),
  updatedAt: z.string().datetime().nullable(),
});
export type OpenAiImageProviderSettingView = z.infer<
  typeof OpenAiImageProviderSettingViewSchema
>;

/** 連線測試結果(借用 AiProviderTestResult 的形狀;tokens 欄位生圖測試不使用)。 */
export const OpenAiImageProviderTestResultSchema = z.object({
  ok: z.boolean(),
  message: z.string(),
  latencyMs: z.number().optional(),
  /** 測試成功時回傳 API 返回的 model 數,讓使用者知道 key 真的能列模型。 */
  modelCount: z.number().optional(),
});
export type OpenAiImageProviderTestResult = z.infer<
  typeof OpenAiImageProviderTestResultSchema
>;
